/**
 * Full-page loading screen shown while Firebase initialises or the backend
 * profile fetch is in-flight after sign-in.
 */
export default function AuthLoadingScreen() {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-card dark:bg-gray-950">
      {/* Spinner */}
      <div className="relative mb-6">
        <div className="w-16 h-16 rounded-full border-4 border-orange-100 dark:border-orange-900" />
        <div className="absolute inset-0 w-16 h-16 rounded-full border-4 border-t-orange-500 animate-spin" />
      </div>

      {/* Brand */}
      <p className="text-lg font-semibold text-tx-primary dark:text-gray-100 tracking-wide">
        Naam Darbar
      </p>
      <p className="mt-1 text-sm text-tx-muted dark:text-gray-500">
        Signing in…
      </p>
    </div>
  );
}
